export const CommonPermissionKeys = Object.freeze({
  ADMINISTRATOR: 'administrator',
  MARKETER: 'marketer',
  INSTRUCTOR: 'instructor',
  HELPDESK: 'helpdesk',
});
